export var MarkTypeEnum;

!function(MarkTypeEnum) {
    MarkTypeEnum.group = "group", MarkTypeEnum.symbol = "symbol", MarkTypeEnum.rule = "rule", 
    MarkTypeEnum.line = "line", MarkTypeEnum.text = "text", MarkTypeEnum.rect = "rect", 
    MarkTypeEnum.image = "image", MarkTypeEnum.path = "path", MarkTypeEnum.area = "area", 
    MarkTypeEnum.arc = "arc", MarkTypeEnum.polygon = "polygon", MarkTypeEnum.boxPlot = "boxPlot", 
    MarkTypeEnum.linkPath = "linkPath", MarkTypeEnum.cell = "cell", MarkTypeEnum.ripple = "ripple", 
    MarkTypeEnum.liquid = "liquid", MarkTypeEnum.component = "component", MarkTypeEnum.dataLabel = "dataLabel", 
    MarkTypeEnum.label = "label", MarkTypeEnum.pictogram = "pictogram";
}(MarkTypeEnum || (MarkTypeEnum = {}));
//# sourceMappingURL=type.js.map
